module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('mu-content-block', {
    attrs: {
      "id": "initialLoader"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isError) ? _c('mu-content-block', {
    attrs: {
      "id": "initialLoader"
    }
  }, [_c('span', [_vm._v("Unauthorized to view article")])]) : _vm._e(), _vm._v(" "), ((!_vm.isLoading && !_vm.isError)) ? _c('article', {
    attrs: {
      "id": "LifeStyleArticle"
    }
  }, [((!_vm.isLoading && !_vm.isError)) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "100",
      "width": "100"
    }
  }, [(_vm.post.post_video && _vm.post.post_format === 'video') ? _c('mu-card', {
    staticStyle: {
      "background": "none",
      "box-shadow": "none"
    }
  }, [_c('div', {
    attrs: {
      "id": "embed-video"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$sanitize(_vm.post.post_video_iframe, {
        allowedAttributes: {
          'iframe': ['width', 'height', 'allow', 'frameborder', 'src', 'webkitallowfullscreen', 'mozallowfullscreen', 'allowfullscreen']
        }
      }))
    }
  })]) : _vm._e(), _vm._v(" "), _c('mu-card', {
    attrs: {
      "id": "articleContent"
    }
  }, [(_vm.post.post_image) ? _c('img', {
    staticClass: "postImg",
    attrs: {
      "src": _vm.post.post_image,
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "byAuthor"
    }
  }, [_c('div', {
    staticClass: "info"
  }, [_c('mu-avatar', {
    attrs: {
      "size": 32,
      "src": _vm.post.post_author_image
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "name",
    domProps: {
      "textContent": _vm._s(_vm.post.post_author)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_c('mu-icon', {
    attrs: {
      "value": "watch_later",
      "color": "#5b617c"
    }
  }), _vm._v(" "), _c('time', {
    attrs: {
      "datetime": _vm.post.post_date
    },
    domProps: {
      "textContent": _vm._s(_vm.moment(_vm.post.post_date).fromNow())
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "favourites"
  }, [_c('mu-icon', {
    attrs: {
      "value": "favorite",
      "color": "#d83e38"
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.post.post_favourites)
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "favouriteBtn"
  }, [_c('mu-flat-button', {
    attrs: {
      "icon": _vm.post.post_favourited ? 'favorite' : 'favorite_border',
      "label": _vm.post.post_favourited ? 'Favourited' : 'Favourite'
    },
    on: {
      "click": function($event) {
        return _vm.favouritePost()
      }
    }
  })], 1)]), _vm._v(" "), _c('h1', {
    staticClass: "postTitle",
    domProps: {
      "innerHTML": _vm._s(_vm.post.post_title)
    }
  }), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "100",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('mu-content-block', [(_vm.userId) ? _c('vue-markdown', {
    staticClass: "markdownContent",
    attrs: {
      "source": _vm.post.post_content
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.userId) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$sanitize(_vm.post.post_excerpt))
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.userId) ? _c('div', {
    staticClass: "loggedOutActions"
  }, [_c('mu-raised-button', {
    attrs: {
      "primary": "",
      "label": "Log in"
    },
    on: {
      "click": _vm.goToLogin
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "label": "Register"
    },
    on: {
      "click": function($event) {
        return _vm.goToRoute('Register')
      }
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('div', {
    attrs: {
      "id": "lifeSidebar"
    }
  }, [(_vm.isLoading === false && !_vm.isHcpView) ? _c('life-similar-posts', {
    attrs: {
      "post_id": _vm.post.post_id,
      "size": "medium-400"
    }
  }) : _vm._e()], 1)])], 1) : _vm._e(), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "100",
      "tablet": "100",
      "width": "100"
    }
  }, [(_vm.userId) ? _c('life-comments', {
    attrs: {
      "postId": _vm.post.post_id,
      "userId": _vm.userId
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.isLoggedOut && !_vm.userId && _vm.attempts.read >= _vm.attempts.amount) ? _c('div', {
    attrs: {
      "id": "lockScreen"
    }
  }, [_c('div', {
    attrs: {
      "id": "lockModal"
    }
  }, [_c('mu-row', [_c('mu-col', {
    staticClass: "desc",
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "50"
    }
  }, [_c('mu-flexbox', {
    attrs: {
      "gutter": 0
    }
  }, [_c('mu-flexbox-item', [_c('h2', [_vm._v("Sorry to interrupt your reading, but...")]), _vm._v(" "), _c('p', [_vm._v("\n                  We noticed that you’ve read " + _vm._s(_vm.attempts.read) + " articles on the Low Carb Lifestyle blog this week.")]), _vm._v(" "), _c('p', [_vm._v("Sign up for unlimited access to all this and loads more.")])])], 1)], 1), _vm._v(" "), _c('mu-col', {
    staticClass: "noAccount",
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "50"
    }
  }, [_c('mu-flexbox', {
    attrs: {
      "gutter": 0,
      "align": "center"
    }
  }, [_c('mu-flexbox-item', [_c('mu-raised-button', {
    staticClass: "signUpBtn",
    attrs: {
      "label": "Sign up",
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToRoute('Register')
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('message.registerHaveAccount')) + "\n                  "), _c('a', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.registerSignIn'))
    },
    on: {
      "click": _vm.goToLogin
    }
  }, [_vm._v("Sign in now")])])], 1)], 1)], 1)], 1)], 1)]) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a2605362","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/LifeStyle/Article/LifeArticle.vue
// module id = 3271
// module chunks = 1